import { ProductMenu } from '../product-menu';
import { Type } from '@angular/core';
import { ProductMenuHeaderComponent } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-header/product-menu-header.component';
import { MenuHeaderTitleImageComponent } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-header/menu-header-title/menu-header-title-image/menu-header-title-image.component';
import { BandedRowMode } from '../../enum/shared/banded-row-mode.enum';
import { FONT, FontStyleSheet } from '../font-style-sheets';
import { WithinNameCell } from '../../enum/shared/within-name-cell';

export class RoyalMenu extends ProductMenu {
  getThemeClass(): string {
    return 'royal-theme';
  }

  whatFontsAreNeededToRenderContent(): FontStyleSheet[] {
    return [FONT.Dongle.Bold_700, FONT.Dongle.Regular_400, FONT.Lato.Black_900, FONT.Lato.Regular_400];
  }

  /**
   * All fonts are sourced from the assets folder
   */
  override getAdobeFontFamilyCssUrl(): string | null {
    return null;
  }

  getHeaderType(): Type<ProductMenuHeaderComponent> {
    return MenuHeaderTitleImageComponent;
  }

  getShowHeader(): boolean {
    return true;
  }

  getShowFooter(): boolean {
    return false;
  }

  getShowInlineLabels(): WithinNameCell {
    return WithinNameCell.TitleLine;
  }

  getProductWrapperClass(odd: boolean) {
    return odd ? '' : 'product-row-overlay';
  }

  bandedRowMode(): BandedRowMode {
    return BandedRowMode.Even;
  }

  bandedRowsDefaultEnabled(): boolean {
    return true;
  }

  getShowProductSubtitle(): boolean {
    return true;
  }

  getColumnGroupingSpacerWidthPercentage(): number {
    return 0;
  }
}
